import * as Api from "./api";
import { normalize } from "normalizr";
import * as actionTypes from "./actionTypes";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { camelizeKeys } from "humps";
import { scoringHistorySchema } from "features/common/schemas";

export function loadDocumentScoringHistorySession(documentId, siteId, sessionID) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    const scoringHistory = getState().entities.scoringHistory;

    const shouldCallApi =
      !scoringHistory.scoringSessions[key] ||
      !scoringHistory.scoringSessions[key][sessionID] ||
      !scoringHistory.scoringSessionsGrids[sessionID];
    if (!shouldCallApi) return;

    try {
      let scoringHistoryGridSession = await dispatch(
        sendHttpRequest(Api.loadScoringHistorySession(documentId, siteId, sessionID))
      );
      dispatch({
        type: actionTypes.LOAD_DOCUMENT_SCORING_HISTORY_SESSION_GRIDS_SUCCESS,
        payload: { key, sessionID, scoringHistoryGridSession: scoringHistoryGridSession }
      });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function loadDocumentScoringHistory(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let scoringHistoryData = getState().document.scoringHistoryData[key];

    const shouldCallApi = !scoringHistoryData || (!scoringHistoryData.loaded && !scoringHistoryData.loading);

    if (!shouldCallApi) return;

    try {
      dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_HISTORY_STARTED, id: key });

      scoringHistoryData = await dispatch(sendHttpRequest(Api.loadScoringHistory(documentId, siteId)));
      const camelizedJson = camelizeKeys(scoringHistoryData);
      const payload = Object.assign({}, normalize(camelizedJson, [scoringHistorySchema]));

      dispatch({ type: actionTypes.LOAD_DOCUMENT_SCORING_HISTORY_SESSION_SUCCESS, payload: payload, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
    }
  };
}
